import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wo_036",
  "use": "icon-wo_036-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-wo_036\"><defs><style>#icon-wo_036 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-wo_036_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-wo_036_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><polygon class=\"cls-2\" points=\"10.71 17.71 9.29 16.29 13.59 12 9.29 7.71 10.71 6.29 16.41 12 10.71 17.71\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol